import {useEffect, useState} from 'react'
import CandidateCard from './CandidateCard'
import axios from 'axios'
import ReactPaginate from 'react-paginate'
import {Spinner} from 'react-bootstrap'
import {scrollToTopOfScrollable} from '../../../utils/helper/helper'

const CandidateMainPage = () => {
  const API_URL = process.env.REACT_APP_API_URL
  const [candidateData, setCandidateData] = useState<any>([])
  const [JobFunctionOptions, setJobFunctionOptions] = useState([])
  const [jobFunction, setJobFunction] = useState('')
  const [searchInput, setSearchInput] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [itemOffset, setItemOffset] = useState(0)
  const itemsPerPage = 10
  const [pageCount, setPageCount] = useState(1)

  const handlePageClick = (event: any) => {
    const newOffset = event.selected
    setItemOffset(newOffset)
  }

  const fetchData = () => {
    setIsLoading(true)
    axios
      .get(
        `${API_URL}/users/admin/get-candidate?function=${jobFunction}&query=${searchInput}&page=${itemOffset}&limit=12`
      )
      .then((response) => {
        setCandidateData(response.data ? response.data : [])
        setPageCount(response.data.totalPages || 1)
        setIsLoading(false)
        scrollToTopOfScrollable()
      })
      .catch((error) => {
        console.error('Error fetching data:', error)
        setIsLoading(false)
      })
  }

  useEffect(() => {
    fetchData()
  }, [jobFunction, itemOffset, searchInput])
  useEffect(() => {
    axios
      .get(`${API_URL}/users/domain/job-function-list`)
      .then((response) => {
        setJobFunctionOptions(response.data)
      })
      .catch((error) => console.log(error))
  }, [])
  const handleChange = (e: any) => {
    e.preventDefault()
    let value = e.target.value
    setSearchInput(value.trimLeft())
    if (value.length && itemOffset !== 0) {
      setItemOffset(0)
    }
  }
  const handleJobFunctionChange = (value: string) => {
    setJobFunction(value)
    if (value.length && itemOffset !== 0) {
      setItemOffset(0)
    }
  }
  return (
    <div>
      <div className='d-flex justify-content-between  flex-column-reverse flex-xxl-row flex-xl-row flex-lg-row flex-md-row flex-sm-row bg-white mb-6 rounded px-5 '>
        <div className='d-flex align-items-center gap-3  p-3'>
          <span> {candidateData?.totalSize} Total</span>
          <div className='search '>
            <input
              type='text'
              className='form-control input-area bg-grey'
              placeholder='Search by name'
              value={searchInput}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className='d-flex align-items-center gap-3 p-3'>
          <span style={{width: '100px'}}>Job Functions</span>
          <div>
            <select
              className='form-select'
              aria-label='Default select example'
              value={jobFunction}
              name='role'
              onChange={(e) => {
                handleJobFunctionChange(e.target.value)
              }}
              style={{width: '150px'}}
            >
              <option value=''>All</option>
              {JobFunctionOptions.map((option: any, i: any) => (
                <option key={i}> {option.name}</option>
              ))}
            </select>
          </div>
        </div>
      </div>
      <div className='card-header bg-white rounded p-2'>
        <h3 className='mx-5'>Approved Candidates</h3>
      </div>

      {!candidateData?.users?.length ? (
        <div className='d-flex p-9 m-9 justify-content-center align-items-center fs-1  fw-bold'>
          {isLoading ? <Spinner /> : 'No Candidate Found'}
        </div>
      ) : (
        <>
          <div className='d-flex justify-content-start flex-wrap flex-column flex-xxl-row flex-xl-row flex-lg-row flex-md-row p-1 mt-5 gap-3'>
            {Array.isArray(candidateData?.users) &&
              candidateData?.users?.map((data: any) => (
                <CandidateCard data={data} key={data?.userId} />
              ))}
          </div>
          <div className='d-flex'>
            {' '}
            <ReactPaginate
              nextLabel='Next >'
              onPageChange={handlePageClick}
              forcePage={itemOffset}
              pageRangeDisplayed={3}
              marginPagesDisplayed={2}
              pageCount={pageCount}
              previousLabel='< Previous'
              pageClassName='page-item'
              pageLinkClassName='page-link'
              previousClassName='page-item'
              previousLinkClassName='page-link'
              nextClassName='page-item'
              nextLinkClassName='page-link'
              breakLabel='...'
              breakClassName='page-item'
              breakLinkClassName='page-link'
              containerClassName='pagination'
              activeClassName='active'
              renderOnZeroPageCount={null}
            />
          </div>
        </>
      )}
    </div>
  )
}

export default CandidateMainPage
